export const ProvincesToOption = (
  provinces: Array<IProvince>,
): Array<IOption> => {
  return provinces
    ?.map(item => {
      return {
        value: item.id,
        label: item.name,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
};

export const CitiesToOption = (cities: Array<ICity>): Array<IOption> => {
  return cities
    ?.map(item => {
      return {
        value: item.id,
        label: item.name,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
};
